import { NotificationManager } from 'react-notifications';
import { SERVER_API } from "../../../config.json";
import Cookies from 'universal-cookie';

const cookies = new Cookies();
let tokenUser = cookies.get('usercode');
function tokenAPI() {
    if (tokenUser.token) {
        return tokenUser.token;
    }
    else {
        NotificationManager.error('Mời bạn đăng nhập lại');
    }
}
let DataTest = [
    {
        ID: 1,
        Task: "Task1",
    },
    {
        ID: 2,
        Task: "Task2",
    },
    {
        ID: 3,
        Task: "Task3",
    },
    {
        ID: 4,
        Task: "Task4",
    },
    {
        ID: 5,
        Task: "Task5",
    },
];
//New
function* GetDataNewFromApi(ID, PlanID) {
    var test = tokenAPI();
    try {
        let DataPlanTypeConfigurationMain = [];
        let DataPlanTypeConfiguration = [];
        const path = window.location.pathname;

        const responsePlanTypeConfigurationMain = yield fetch(SERVER_API + 'api/PlanTypeConfigurationMain/GetListStepByPlanType', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify({ "ID": parseInt(ID), "PlanID": PlanID ? parseInt(PlanID) : 0, "Type": path.includes('Edit') ? 2 : 1 }),
        });
        if (responsePlanTypeConfigurationMain.status === 403) {
            NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
        }
        else if (responsePlanTypeConfigurationMain.status === 404) {
            NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
        }
        else if (responsePlanTypeConfigurationMain.status === 200) {
            DataPlanTypeConfigurationMain = yield responsePlanTypeConfigurationMain.json();
        }
        else {
            DataPlanTypeConfigurationMain = yield {};
        }

        const responsePlanTypeConfiguration = yield fetch(SERVER_API + 'api/PlanTypeConfiguration/GetPlanTypeConfigurationByPlanType', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify({ "ID": parseInt(ID), "PlanID": PlanID ? parseInt(PlanID) : 0, "Type": path.includes('Edit') ? 2 : 1 }),
        });
        if (responsePlanTypeConfiguration.status === 200) {
            DataPlanTypeConfiguration = yield responsePlanTypeConfiguration.json();
        }
        return {
            PlanTypeConfiguration: DataPlanTypeConfiguration.data,
            PlanTypeConfigurationMain: DataPlanTypeConfigurationMain.data,
        }
    }
    catch (ex) {
        console.error("catch", ex)
        return [];
    }
}
function* SetDataNewFromApi(DataNew) {
    var test = tokenAPI();
    if (DataNew.Status === "Save") {
        const response = yield fetch(SERVER_API + 'api/Plan/SetPlan', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify(DataNew),
        });
        if (response.status === 403) {
            NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
        }
        else if (response.status === 404) {
            NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
        }
        else if (response.status === 200) {
            const Data = yield response.json();
            if (Data.status === "OK") {
                NotificationManager.success("Thêm kế hoạch thành công");
                return true;
            }
            else {
                NotificationManager.error("Thêm kế hoạch thất bại");
                return false;
            }
        }
    }
    else if (DataNew.Status === "Edit") {
        const response = yield fetch(SERVER_API + 'api/Plan/SetPlan', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify(DataNew),
        });
        if (response.status === 403) {
            NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
        }
        else if (response.status === 404) {
            NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
        }
        else if (response.status === 200) {
            const Data = yield response.json();
            if (Data.status === "OK") {
                NotificationManager.success("Cập nhật kế hoạch thành công");
                return true;
            }
            else {
                NotificationManager.error("Cập nhật kế hoạch thất bại");
                return false;
            }
        }
    }
    else {
        const response = yield fetch(SERVER_API + 'api/PlanTypeConfiguration/SetDefaultPlanTypeConfiguration', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify(DataNew.PlanTypeConfigurationValue),
        });
        if (response.status === 403) {
            NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
        }
        else if (response.status === 404) {
            NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
        }
        else if (response.status === 200) {
            const Data = yield response.json();
            if (Data.status === "OK") {
                NotificationManager.success("Thêm kế hoạch mặt định thành công");
                return true;
            }
            else {
                NotificationManager.error("Thêm kế hoạch mặt định thất bại");
                return false;
            }
        }
    }
}
function* UploadFileFromApi(File) {
    try {
        var test = tokenAPI();

        const cookies = new Cookies();
        const email = cookies.get('usercode').email
        const formData = new FormData()
        formData.append('File', File)
        formData.append('User', email)
        const response = yield fetch(SERVER_API + "api/File/UploadFile", {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + test },
            body: formData
        });
        const DataFile = yield response.json();

        if (DataFile.status === "OK") {
            return yield DataFile.data;
        }
        else {
            return yield {}
        }
    }
    catch (err) {
        console.log(err)
    }
}
//PlanHandle
function* GetDataPlanHandleFromApi(DataPlanHandle) {
    var test = tokenAPI();
    //var test = yield token();
    const response = yield fetch(SERVER_API + "api/PlanType/GetListDetailPlanTypeByID", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
            //'Authorization':'Bearer '+ test,
        },
        body: JSON.stringify(DataPlanHandle)
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
    }
    else if (response.status === 404) {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    }
    else if (response.status === 200) {
        const DataMainreturn = yield response.json();

        if (DataMainreturn.status === "OK") {
            return yield JSON.parse(DataMainreturn.data);
        }
        else {
            return yield {};
        }
    }
}
function* SetDataPlanHandleFromApi(DataPlanHandle) {
    if (!DataPlanHandle.StatusDelete) {
        if (!DataPlanHandle.ID) {
            let ID = 1;
            // eslint-disable-next-line 
            DataTest.map((item) => {
                if (item.ID >= ID) {
                    ID = item.ID;
                }
            })
            DataTest.push({ ID: ID + 1, Task: DataPlanHandle.Task })
            NotificationManager.success("Thêm thành công");
            return true;
        }
        else {
            // eslint-disable-next-line 
            DataTest.map((item) => {
                if (item.ID === DataPlanHandle.ID) {
                    item.Task = DataPlanHandle.Task;
                }
            });
            NotificationManager.success("Sửa thành công");
            return true;
        }
    }
    else {
        var index1;
        // eslint-disable-next-line 
        DataTest.map((item, index) => {
            if (item.ID === DataPlanHandle.ID) {
                index1 = index;
            }
        });

        if (index1 !== undefined) {
            NotificationManager.success("Xóa thành công");
            DataTest.splice(index1, 1);
            return yield true;
        } else {
            NotificationManager.error("Task không tồn tại");
            return false;
        }
    }
    // return yield false;
}
//PlanHandleStep
function* GetDataPlanHandleStepFromApi(ID, step) {
    var test = tokenAPI();
    // const cookies = new Cookies();
    // const userCode = cookies.get('usercode').userCode;
    const response = yield fetch(SERVER_API + 'api/Plan/GetPlan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ ID: ID, HandleStep: step }), //CreateBy: userCode
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
    }
    else if (response.status === 404) {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    }

    return [];
}
function* SetDataPlanHandleStepFromApi(DataPlanHandleStep) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/Action/ActionActivated', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify(DataPlanHandleStep),
    });
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    }

    return [];
}
function* Downloadfile(value) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + `api/File/DownloadFile?ID=${value}`, { headers: { 'Authorization': 'Bearer ' + test } });
    if (response.status !== 200) {
        NotificationManager.error("Không thể tải file");
    }
    else {
        const filename = response.headers.get('Content-Disposition').split('filename')[1].split('"')[1];
        const blob = yield response.blob();
        const url = window.URL.createObjectURL(
            new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            filename,
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }
}

function* GetFilterReportFromApi(ID) {
    var test = tokenAPI();
    // const cookies = new Cookies();
    // const userCode = cookies.get('usercode').userCode;
    const response = yield fetch(SERVER_API + 'api/PlanTypeConfiguration/GetFilterReportByPlanType', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ ID: ID }),
    });
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    } else {
        return yield {};
    }
}

function* GetDataTableReportFromApi(ID, DataTables) {
    var test = tokenAPI();
    // const cookies = new Cookies();
    // const userCode = cookies.get('usercode').userCode;
    const response = yield fetch(SERVER_API + 'api/PlanType/GetDataTableReport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ PlanTypeID: ID, DataTables: DataTables }),
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
    }
    else if (response.status === 404) {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    } else {
        return yield {};
    }
}

function* GetHeaderTableReportFromApi(ID) {
    var test = tokenAPI();
    // const cookies = new Cookies();
    // const userCode = cookies.get('usercode').userCode;
    const response = yield fetch(SERVER_API + 'api/PlanTypeConfiguration/GetHeaderTableReport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ ID: ID }), //, CreateBy: userCode
    });
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    } else {
        return yield {};
    }
}

//PlanHandleStep
function* GetLogsByPlanID(planID) {

    //console.log("planID API", planID)
    var test = tokenAPI();

    const response = yield fetch(SERVER_API + 'api/Action/GetHistoryByPlanID', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ PlanID: planID }),
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
    }
    else if (response.status === 404) {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    }

    return [];
}

//PlanHandleStep
function* GetStatusActionHistoryFromApi(planID) {
    var test = tokenAPI();

    const response = yield fetch(SERVER_API + 'api/Plan/GetStatusActionHistory', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ PlanID: planID }),
    });
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    }

    return [];
}

//Getdata Link api
function* GetDataLinkApi(DataLinkApi) {
    var test = tokenAPI();
    try {
        const responseLinkapi = yield fetch(SERVER_API + 'api/Action/GetprojectsApi', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify(DataLinkApi.DataLinkApi),
        });
        if (responseLinkapi.status === 200) {
            return yield responseLinkapi.json();
        }
        return [];
    }
    catch (ex) {
        console.error("catch", ex)
        return [];
    }
}

//Getdata Link api by id
function* GetDataLinkApibyid(DataLinkApibyid) {
    var test = tokenAPI();
    try {
        const responseLinkapi = yield fetch(SERVER_API + 'api/Action/GetprojectsApi', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify(DataLinkApibyid.DataLinkApibyid),
        });
        if (responseLinkapi.status === 200) {
            return yield responseLinkapi.json();
        }
        return [];
    }
    catch (ex) {
        console.error("catch", ex)
        return [];
    }
}

// Getdata Email Azure by name
function* GetDataEmailAzureByName(Data) {
    var test = tokenAPI();
    try {
        const responseLinkapi = yield fetch(SERVER_API + 'api/AzureEmail/GetMailByKey', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify({ Keyword: Data.DataEmailAzure })
        });
        if (responseLinkapi.status === 200) {
            return yield responseLinkapi.json();
        }
        return [];
    }
    catch (ex) {
        console.error("catch", ex)
        return [];
    }

}

// Get data validate
function* GetDataValidateDate(DataValidate) {
    var test = tokenAPI();
    try {
        const response = yield fetch(SERVER_API + 'api/PlanType/GetIsValidateDate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
            body: JSON.stringify(DataValidate)
        });
        if (response.status === 200) {
            const Data = yield response.json();
            return yield Data.data;
        }
        return [];
    }
    catch (ex) {
        console.error("catch", ex)
        return [];
    }
}
//GetDataPlanByPass
function* GetDataPlanByPass() {
    var test = tokenAPI();
    try {
        const response = yield fetch(SERVER_API + 'api/Plan/GetPlanByPassCreate', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test }
        });
        if (response.status === 200) {
            const Data = yield response.json();
            return yield Data.data;
        }
        return [];
    }
    catch (ex) {
        console.error("catch", ex)
        return [];
    }
}

//CreateFuntionHygen
export const Api = {
    GetDataNewFromApi,
    SetDataNewFromApi,
    GetDataPlanHandleFromApi,
    SetDataPlanHandleFromApi,
    GetDataPlanHandleStepFromApi,
    SetDataPlanHandleStepFromApi,
    UploadFileFromApi,
    Downloadfile,
    GetFilterReportFromApi,
    GetDataTableReportFromApi,
    GetHeaderTableReportFromApi,
    GetLogsByPlanID,
    GetStatusActionHistoryFromApi,
    GetDataLinkApi,
    GetDataLinkApibyid,
    GetDataEmailAzureByName,
    GetDataValidateDate,
    GetDataPlanByPass,
    //ExportFuntionHygen
}